const colors = {
  background: {
    default: "#f4f7ef",
    paper: "#ffffff",
    sidenav: "#143124",
  },

  text: {
    main: "#4e6352",
    focus: "#294233",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#2f7a42",
    focus: "#256236",
  },

  secondary: {
    main: "#607667",
    focus: "#4f6357",
  },

  info: {
    main: "#214f6c",
    focus: "#183d54",
  },

  success: {
    main: "#4f9c5d",
    focus: "#3f824c",
  },

  warning: {
    main: "#dd8e2f",
    focus: "#c77a1f",
  },

  error: {
    main: "#d1553f",
    focus: "#b94631",
  },

  light: {
    main: "#eff5e9",
    focus: "#e5efdc",
  },

  dark: {
    main: "#183526",
    focus: "#10271c",
  },

  grey: {
    100: "#fbfcf8",
    200: "#eff3ea",
    300: "#dce5d8",
    400: "#c2cec0",
    500: "#9eaea1",
    600: "#6d7f71",
    700: "#495a4d",
    800: "#2c3d30",
    900: "#18261c",
  },

  gradients: {
    primary: {
      main: "#3a8b4f",
      state: "#245b33",
    },
    secondary: {
      main: "#708478",
      state: "#4b5e52",
    },
    info: {
      main: "#2c688b",
      state: "#193f59",
    },
    success: {
      main: "#66ab72",
      state: "#427d4a",
    },
    warning: {
      main: "#eca145",
      state: "#c57a22",
    },
    error: {
      main: "#e07157",
      state: "#b84a37",
    },
    light: {
      main: "#ffffff",
      state: "#edf2e7",
    },
    dark: {
      main: "#214631",
      state: "#10281b",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },
    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },
    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },
    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },
    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },
    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },
    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },
    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },
    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },
    github: {
      main: "#24292e",
      dark: "#171a1d",
    },
    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },
    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#d2edd8",
      text: "#245b33",
    },
    secondary: {
      background: "#d9e3dc",
      text: "#4b5e52",
    },
    info: {
      background: "#d5e8f3",
      text: "#183d54",
    },
    success: {
      background: "#d8eedc",
      text: "#427d4a",
    },
    warning: {
      background: "#f8e1bf",
      text: "#a76113",
    },
    error: {
      background: "#f8d7d1",
      text: "#ab3e2d",
    },
    light: {
      background: "#ffffff",
      text: "#90a498",
    },
    dark: {
      background: "#bed0c2",
      text: "#143124",
    },
  },

  coloredShadows: {
    primary: "#2f7a42",
    secondary: "#607667",
    info: "#214f6c",
    success: "#4f9c5d",
    warning: "#dd8e2f",
    error: "#d1553f",
    light: "#c8d3c7",
    dark: "#183526",
  },

  inputBorderColor: "#d6dfd1",

  tabs: {
    indicator: { boxShadow: "#d6dfd1" },
  },
};

export default colors;
